import React from 'react';
import ReactDOM from 'react-dom';
import MakingCall from './MakingCall';
import ContactMessage from './ContactMessage';
import defaultPicture from '../images/contact-default.png';

export default class ContactCard extends React.Component {
  constructor(props) {
    super(props);
    this.defaultPicture = defaultPicture;
    this.startCall = this.startCall.bind(this);
  }

  startCall() {
    if (this.props.status === 'offline') return;
    this.props.socket.emit('call', { email: this.props.email }, (contactHasAdded) => {
      if (contactHasAdded) {
        window.MakingCall.startCall();
      } else {
        ReactDOM.unmountComponentAtNode(document.getElementById('makingCall'));
        ReactDOM.render(
          <ContactMessage
            name={this.props.name}
            msgKey="contactHasNotAdded"
          />,
          document.getElementById('contactMessage'));
      }
    });
    ReactDOM.render(
      <MakingCall
        socket={this.props.socket}
        name={this.props.name}
        email={this.props.email}
        picture={this.props.picture}
      />,
      document.getElementById('makingCall'));
  }

  render() {
    const locale = global.dictionaries.calling;
    return (
      <div className="contact-card">
        <img
          src={this.props.picture || this.defaultPicture}
          className="image"
          alt={this.props.name}
        />
        <p className="name">{this.props.name}</p>
        <hr />
        <p
          className={this.props.status === 'online' ? 'call-button green' : 'call-button'}
          title={this.props.status === 'online' ? 'Online' : 'Offline'}
          onClick={this.startCall}
        >
          <span className="icon">
            <i className="fa fa-phone" />
          </span>&nbsp;
          <span style={{ textTransform: 'capitalize' }}>{locale.call}</span>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactCard.js